import React from 'react'
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useState } from "react";
import { useNavigate } from 'react-router-dom';
import GetIcon from "../../../../utils/Icon";
import printerimg from "../../../../assets/print.png"
import Button from "../../../../Core/Button/Button";
import FormLayout from "../../../../Core/Layout/FormLayout";
import { useCreateSalesTaxTemplateMutation, useGetSalesTaxTemplateByNameQuery, useUpdateSalesTaxTemplateMutation } from '../../../../store/api/Salestaxes';
import ApiResponseBox from '../../../../Components/ApiResponseBox';
import Tab1 from "./Tab1";
import Tab2 from './Tab2';
import Attachment from '../../../../utils/Attachment';
function Tax() {
    const location = useLocation()
    const salestaxId = location?.state?.taxId
    const navigate = useNavigate()
    const [tab, settab] = useState(1)
    const [taxes, setTaxes] = useState([])
    const [error, setError] = useState('');
    const [ptype, setptype] = useState("Error")
    const [showError, setShowError] = useState(false);
    const [createSalesTax] = useCreateSalesTaxTemplateMutation();
    const { data, isLoading, isError } = useGetSalesTaxTemplateByNameQuery(salestaxId);
    const [updateTemplate] = useUpdateSalesTaxTemplateMutation();
    const [compname, setname] = useState('')
    const [formdata, setformdata] = useState({
        title: "",
        taxcategory: "",
        company: "",
        default: false,
        disabled: false
    });
    const [detaildata, setDetaildata] = useState([])
    useEffect(() => {
        if (data?.data) {
            const { title, tax_category, company, is_default, disabled } = data.data
            setDetaildata(data.data.taxes)
            setformdata({
                title: title || "",
                taxcategory: tax_category || "",
                company: company || "",
                default: Boolean(is_default),
                disabled: Boolean(disabled)
            })

        }

    }, [data])
    useEffect(() => {
        if (formdata.company) {
            setname(formdata.company);
        }
    }, [formdata.company]);

    const handlechange = (e) => {
        const { name, value } = e.target;
        setformdata((prev) => ({
            ...prev,
            [name]: value
        }));
    };
    const handleSubmit = async () => {
        const payload = { title: formdata.title, company: formdata.company, tax_category: formdata.taxcategory, is_default: formdata.default, disabled: formdata.disabled, taxes: taxes };
        try {
            const res = await updateTemplate({
                name: salestaxId,
                payload
            }).unwrap();
            setError('Sales Taxes and Charges Template updated successfully!');
            setptype('Success');
            setShowError(true);
            setTimeout(() => {
                navigate('/master/tax/tax-list')
            }, 3000);
        } catch (error) {
            const parsedMessages = JSON.parse(error.data._server_messages);
            const firstMessageObj = JSON.parse(parsedMessages[0]);
            console.log(firstMessageObj, "errr");
            setError(firstMessageObj.message);
            setptype('Error');
            setptype('Error');
            setShowError(true);
        }
    };
    return (
        <>
            <FormLayout
                title="Edit Sales Taxes and Charges Template"
                breadcrumbs={[
                    { label: " Taxes and Charges Template" },
                    { label: " Taxes and Charges Template List", url: "/master/tax/tax-list" }
                ]}
                status={'hide'}
                actionButtons={
                    <>
              
                        <Button
                            className="custom-btn-00989"
                            iconName="LuFilePlus2"
                            style={{ gap: '2px', height: '28px' }}
                            onClick={handleSubmit}
                            iconSize={12}
                        >Update
                        </Button>
                        <Button
                            to="/brand/create-brand"
                            className="px-2"
                            imgSrc={printerimg}
                            imgStyle={{ width: '21px' }}
                        />
                    </>
                }
            >
                <div className="" style={{ width: "100%", backgroundColor: "#fff", flexGrow: '1' }}>
                    <div className="col-12 p-0" style={{ backgroundColor: '#eff4f9' }}>
                        <div className="d-flex justify-content-between align-items-end ">
                            <ul className="nav nav-tabs" style={{ color: "white", border: "none" }}>
                                <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner" >
                                    <a className={tab == 1 ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner" : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"} onClick={() => { settab(1) }} href="javascript:void(0);">
                                        General Details{tab == 1 ? <GetIcon iconName="MdKeyboardArrowDown" size={15} /> : <GetIcon iconName="MdKeyboardArrowRight" size={15} />}
                                    </a>
                                </li>
                            </ul>
                             <Attachment doctype="Sales Taxes and Charges Template"  docname={salestaxId}  /> 
                        </div>
                    </div>
                    <div className="mt-2 py-2" style={{ width: "100%", backgroundColor: "#fff", flexGrow: '1' }}>
                        <div className="row d-flex justify-content-between">
                            <div className="col-12" >
                                <div className="sidebarbox m-0 px-4 py-2">
                                    <Tab1 setformdata={setformdata} formdata={formdata} handlechange={handlechange} />
                                </div>
                            </div>
                        </div>
                        <div className="row d-flex justify-content-between">
                            <div className="col-12" >
                                <div className="sidebarbox m-0 px-4 py-2">
                                    <Tab2 setTaxes={setTaxes} taxes={taxes} detaildata={detaildata} compname={compname} salestaxId={salestaxId} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ApiResponseBox
                    poptype={ptype}
                    show={showError}
                    errorMessage={error}
                    onClose={() => setShowError(false)}
                />
            </FormLayout>
        </>
    )
}

export default Tax
